export class ModeException extends Error {
    constructor(message: string) {
        super(message);
        this.name = 'ModeException';
    }
}

